// For Admin CSR pages and related data

import { defineStore } from 'pinia'
import { ref } from 'vue'

import type { Course } from '@/javascript/interfaces'

import api from '../services/api'
import { getContentPackageFolderList } from '../services/packages'
import type { ContentPackage, ContentPackageFolder } from '../services/packages/interfaces'
import type { Certification, Curriculum } from '../services/trainingCurriculums/interfaces'
import GlobalStore from './GlobalStore'

export const usePackagesAndProgramsStore = defineStore('packagesAndPrograms', () => {
	// State
	const allAvailablePackagesAndFolders = ref<ContentPackageFolder[]>([])
	const allFolders = ref<ContentPackageFolder[]>([])
	const certifications = ref<Certification[]>([])
	const contentPackages = ref<ContentPackage[]>([])
	const courses = ref<Course[]>([])
	const curriculums = ref<Curriculum[]>([])
	const selectedFolder = ref<ContentPackageFolder | undefined>(undefined)

	// Actions
	const getAllContentPackageFolders = async () => {
		try {
			const response = await getContentPackageFolderList(api)

			allFolders.value = response
		} catch (error) {
			GlobalStore.onHandleErrorMessages({ error })
		}
	}

	return {
		// State
		allAvailablePackagesAndFolders,
		allFolders,
		certifications,
		contentPackages,
		courses,
		curriculums,
		selectedFolder,

		// Actions
		getAllContentPackageFolders,
	}
})
